/* ==================================================================
   Banaya — Assistant garanties
   JavaScript autonome, sans React ni étape de compilation.
   Se greffe sur l'élément portant l'identifiant banaya-assistant.

   Attributs lus sur le conteneur :
     data-relais    URL du Worker (obligatoire)
     data-formule   Accessible | Smart | Premium   (défaut Smart)
     data-selecteur "1" pour afficher le sélecteur de formule
   ================================================================== */
(function () {
  "use strict";

  var BEIGE = "#EEE7D7", CREME = "#F5F1E8", SABLE = "#ddd6c4";
  var NOIR = "#000", GRIS = "#5f5f5f", GRIS2 = "#5a5a5a", TRAIT = "#e8e8e8";

  /* Extraits contractuels affichés au clic sur une référence. */
  var REFS = {
    "2.1": ["éligibilité", "Chien ou chat, plus de 2 mois et moins de 9 ans à l'adhésion, identifié par tatouage ou puce, numéro porté au certificat d'adhésion. Adhérent : personne physique majeure résidant en France métropolitaine."],
    "2.2": ["restrictions d'âge", "Les animaux de 7 à 9 ans à l'adhésion ne peuvent souscrire que les formules dont le taux est inférieur ou égal à 80 %. À partir des 9 ans de l'animal, le taux de la garantie Maladie diminue de 5 points par année d'assurance, sans descendre sous 30 %."],
    "2.3": ["non assurables", "Animaux d'élevages professionnels, animaux utilisés dans une activité professionnelle, animaux non identifiés ou non désignés au certificat d'adhésion, tout animal autre que chien ou chat."],
    "3.2": ["taux et plafonds", "Accessible 60 % et 1 000 €. Smart 70 % et 1 500 €. Premium 100 % et 1 000, 2 000 ou 3 000 €. Le forfait Prévention est une enveloppe distincte du plafond frais vétérinaires."],
    "3.3": ["actes couverts, accident", "Honoraires, soins et médicaments prescrits, analyses, radiologie, échographie, scanner et IRM, ambulance animalière justifiée, hospitalisation et chirurgie, séjour en clinique nécessité par une intervention, pharmacie et anesthésie liées à l'intervention, euthanasie en cas d'accident."],
    "3.4": ["actes couverts, maladie", "Mêmes postes que l'accident, plus l'euthanasie en cas de maladie et les maladies vaccinables survenues malgré l'injection du vaccin préventif."],
    "3.5": ["maladies vaccinables", "Chiens : Carré, Rubarth, parvovirose, piroplasmose, leptospirose, rage. Chats : typhus, coryza, leucose féline, rage. Couvertes si l'animal était vacciné, exclues à défaut de vaccin préventif."],
    "3.6": ["option prévention", "Réservée aux formules Smart et Premium, sans délai de carence. Liste limitative de 22 actes. Stérilisation plafonnée à 100 € par an, croquettes Banaya limitées à 50 % du forfait, ostéopathie réservée aux praticiens reconnus par le CNOV."],
    "3.7": ["conditions de prise en charge", "Adhésion en cours, carence écoulée, actes prescrits et exécutés par un vétérinaire inscrit à l'ordre, diagnostic pour la maladie, déclaration sous 5 jours, pièces fournies, cotisation à jour."],
    "3.8": ["délais de carence", "Accident 2 jours francs. Maladie 45 jours francs. Hospitalisation, chirurgie suite à maladie, ligaments croisés, hernie discale : 120 jours francs. Prévention : aucun délai. Une pathologie dont les premiers symptômes apparaissent pendant la carence n'est jamais prise en charge."],
    "3.10": ["pièces justificatives", "Feuille de soins remplie, signée et tamponnée par le vétérinaire, facture acquittée détaillée du même montant, preuve de règlement, ordonnance le cas échéant, preuve de vaccination pour les maladies vaccinables, RIB."],
    "4.1-1": ["maladies vaccinables non vaccinées", "Les frais exposés par les maladies listées survenues en l'absence de vaccin préventif sont exclus."],
    "4.1-2": ["maladies antérieures", "Toutes les maladies survenues ou constatées avant l'adhésion, et leurs conséquences."],
    "4.1-3": ["symptômes antérieurs", "Toutes les maladies dont les symptômes sont antérieurs à la date d'adhésion, et leurs conséquences. Le symptôme suffit, le diagnostic n'est pas nécessaire."],
    "4.1-4": ["accidents antérieurs", "Tous les accidents survenus ou constatés avant l'adhésion, et leurs conséquences."],
    "4.1-5": ["hospitalisation pendant la carence", "Les hospitalisations et leurs conséquences intervenues pendant les délais de carence."],
    "4.1-6": ["origine congénitale", "L'ensemble des frais exposés, y compris de dépistage, pour toute infirmité ou malformation liée à une maladie d'origine congénitale, héréditaire ou génétique."],
    "4.1-7": ["luxation des rotules", "Pour les chiens, la luxation des rotules est exclue quelle qu'en soit la cause, congénitale comme accidentelle."],
    "4.1-8": ["médicaments hors pathologie", "Tout médicament prescrit sans rapport avec la pathologie déclarée."],
    "4.1-9": ["chirurgie esthétique", "Toute intervention destinée à atténuer ou supprimer des défauts esthétiques et non fonctionnels."],
    "4.1-10": ["prothèses", "Prothèses dentaires, oculaires et articulaires exclues. Les prothèses orthopédiques en cas d'accident sont couvertes."],
    "4.1-11": ["piqûres d'arthropodes", "Les frais générés par les piqûres d'arthropode sont exclus, sauf les piqûres de guêpes et d'abeilles."],
    "4.1-13": ["mises bas et césariennes", "Exclues lorsqu'elles ne sont pas occasionnées par un accident."],
    "4.1-14": ["gestation", "Diagnostic, suivi de gestation, avortement et ses conséquences, insémination artificielle."],
    "4.1-16": ["stérilisation de convenance", "Contraceptions et stérilisations de convenance des femelles exclues. La stérilisation reste couverte jusqu'à 100 € par an au titre de l'option Prévention."],
    "4.1-17": ["identification", "Frais de puce électronique et de tatouage exclus, alors même que l'identification conditionne l'éligibilité."],
    "4.1-18": ["rage", "Diagnostic de la rage, euthanasie pour la rage et test sérologique antirabique exclus, indépendamment du statut vaccinal."],
    "4.1-19": ["mordeur ou griffeur", "Frais de visite et de garde d'un chien ou chat classé mordeur ou griffeur."],
    "4.1-21": ["troubles du comportement", "Diagnostic, visite d'évaluation, médicaments et thérapie comportementale. La définition contractuelle y rattache la malpropreté urinaire, l'hypersexualité et les troubles pubertaires."],
    "4.1-22": ["frais après décès", "Enlèvement, autopsie et inhumation de l'animal."],
    "4.1-23": ["euthanasie de convenance", "Frais d'euthanasie en dehors de la maladie et de l'accident."],
    "4.1-25": ["ambulance non justifiée", "Transport en ambulance animalière non prescrit par un vétérinaire et non justifié par l'état de santé de l'animal."],
    "4.1-26": ["défaut de soins", "Frais occasionnés ou aggravés par des mauvais traitements, un manque de soins ou un défaut de nourriture."],
    "4.1-27": ["activités à risque", "Chasse, combats organisés, courses, compétitions sportives et leurs entraînements."],
    "4.1-30": ["cataracte", "La cataracte des chiens âgés de plus de 8 ans est exclue. Les chats ne sont pas concernés."],
    "4.2": ["liste congénitale", "Dysplasies de la hanche et du coude, ostéochondrite et ostéochondrose disséquantes, hernies ombilicales, syndrome brachycéphale, atteintes congénitales de l'œil, anomalies de dentition, ectopie testiculaire, cardiopathies et maladies respiratoires congénitales."],
    "4.3": ["exclusions de la garantie de base", "Alimentation diététique, vaccins préventifs, vermifuge, détartrage, produits antiparasitaires, thérapies non conventionnelles et traitements immunologiques. Ces actes sont couverts si l'option Prévention est souscrite."],
    "4.4": ["exclusions de l'option prévention", "Ostéopathie non réalisée par un praticien reconnu par l'Ordre des Vétérinaires. Tout acte non expressément listé."],
    "4.6": ["déchéances", "Fausse déclaration, fraude, déclaration tardive au-delà de 5 jours, pièces non transmises, non-paiement de la cotisation."],
    "4.7": ["limites de remboursement", "Taux, plafond annuel, forfait Prévention, sous-limites stérilisation et croquettes, dégressivité liée à l'âge."]
  };

  /* Le beige porte ce qui est pris en charge, le noir ce qui ne l'est pas :
     même sémantique que l'exemple chiffré de la page assurance. */
  var STATUTS = {
    "COUVERT":        { fond: BEIGE,     texte: NOIR,  past: NOIR,      glyphe: "\u2713", pg: BEIGE },
    "SOUS CONDITION": { fond: CREME,     texte: NOIR,  past: NOIR,      glyphe: "!",      pg: BEIGE },
    "EXCLU":          { fond: NOIR,      texte: BEIGE, past: BEIGE,     glyphe: "\u2715", pg: NOIR },
    "NON ASSURABLE":  { fond: NOIR,      texte: BEIGE, past: BEIGE,     glyphe: "\u2715", pg: NOIR },
    "PRÉCISION REQUISE": { fond: CREME,   texte: NOIR,  past: NOIR,      glyphe: "?",      pg: BEIGE },
    "HORS PÉRIMÈTRE": { fond: "#F4F4F4", texte: "#565656", past: "#c7bda2", glyphe: "?",  pg: "#fff" }
  };

  var AMORCES = [
    "à partir de quand suis-je couvert ?",
    "la stérilisation, remboursée ?",
    "piqûre de tique",
    "boiterie apparue avant l'adhésion",
    "que couvre l'option prévention ?",
    "quels vaccins pour être couvert ?"
  ];

  var MENTION_COURTE = "Réponse indicative. Seule la notice d’information fait foi.";
  var MENTION_LONGUE = "Réponse générée automatiquement à partir des garanties du contrat, à valeur informative. Elle ne constitue ni un conseil personnalisé, ni une décision de prise en charge, ni un engagement de Banaya ou de l’assureur. Seule la notice d’information remise avant l’adhésion fait foi. Vos messages sont transmis à un service tiers d’intelligence artificielle aux seules fins de produire la réponse.";

  var FORMULES = {
    Accessible: { taux: "60 %", plafond: "1 000 €", prev: null },
    Smart:      { taux: "70 %", plafond: "1 500 €", prev: "100 €" },
    Premium:    { taux: "100 %", plafond: null,     prev: "100 à 200 €" }
  };

  /* --------------------------- outils --------------------------- */

  function el(balise, classe, texte) {
    var n = document.createElement(balise);
    if (classe) n.className = classe;
    if (texte != null) n.textContent = texte;
    return n;
  }

  function pastille(fond, couleur, glyphe, taille) {
    var s = el("span", "bnya-past", glyphe);
    s.setAttribute("aria-hidden", "true");
    s.style.setProperty("--bnya-t", (taille || 22) + "px");
    s.style.background = fond;
    s.style.color = couleur;
    return s;
  }

  function cartouche(texte) {
    var p = el("p", "bnya-cartouche");
    var t = el("span", "bnya-filet");
    t.setAttribute("aria-hidden", "true");
    p.appendChild(t);
    p.appendChild(document.createTextNode(texte));
    return p;
  }

  function styles() {
    if (document.getElementById("bnya-styles")) return;
    var s = el("style");
    s.id = "bnya-styles";
    s.textContent = [
      ".bnya{font-family:'Nunito','Futura','Century Gothic',sans-serif;color:#000;background:#fff;border:1px solid " + TRAIT + ";display:flex;flex-direction:column;overflow:hidden}",
      ".bnya *{box-sizing:border-box}",
      ".bnya button{font-family:inherit;cursor:pointer}",
      ".bnya-cartouche{display:flex;align-items:center;gap:12px;margin:0;font-size:9px;font-weight:800;letter-spacing:4px;text-transform:uppercase;color:" + GRIS + "}",
      ".bnya-filet{display:block;width:24px;height:1px;background:#888;flex-shrink:0}",
      ".bnya-past{border-radius:50%;font-weight:900;display:flex;align-items:center;justify-content:center;flex-shrink:0;line-height:1;width:var(--bnya-t,22px);height:var(--bnya-t,22px);font-size:calc(var(--bnya-t,22px)*.55)}",
      ".bnya-corps{display:flex;min-height:520px}",
      ".bnya-aside{width:280px;flex-shrink:0;background:" + CREME + ";border-right:1px solid " + SABLE + ";padding:26px 22px;overflow-y:auto}",
      ".bnya-main{flex:1;display:flex;flex-direction:column;min-width:0}",
      ".bnya-fil{flex:1;overflow-y:auto;padding:18px 18px 20px;max-height:62vh}",
      ".bnya-fil::-webkit-scrollbar{width:9px}.bnya-fil::-webkit-scrollbar-thumb{background:#d8d8d8}",
      ".bnya-titre{margin:16px 0 0;font-size:clamp(26px,3.4vw,38px);font-weight:900;letter-spacing:-1.6px;text-transform:lowercase;line-height:.96}",
      ".bnya-titre em{font-style:italic;font-weight:300;letter-spacing:-1.1px}",
      ".bnya-intro{margin:14px 0 0;max-width:52ch;font-size:13.5px;font-weight:400;line-height:1.6;color:" + GRIS + "}",
      ".bnya-exemples{margin:16px 0 9px;font-size:9px;font-weight:800;letter-spacing:2.4px;text-transform:uppercase;color:" + GRIS + "}",
      ".bnya-amorces{display:flex;flex-direction:column;gap:7px}",
      ".bnya-amorce{width:100%;text-align:left;border:1px solid " + SABLE + ";background:#fff;padding:10px 13px;display:flex;align-items:center;justify-content:space-between;gap:12px;transition:background .2s,border-color .2s}",
      ".bnya-amorce:hover{background:" + CREME + ";border-color:#000}",
      ".bnya-amorce span:first-child{font-size:13px;font-weight:800;letter-spacing:-.2px;text-transform:lowercase;line-height:1.25}",
      ".bnya-fleche{flex-shrink:0;font-size:13px;font-weight:800;transition:transform .3s cubic-bezier(.2,.8,.2,1)}",
      ".bnya-amorce:hover .bnya-fleche{transform:translateX(6px)}",
      ".bnya-echanges{display:flex;flex-direction:column;gap:14px}",
      ".bnya-question{align-self:flex-end;max-width:82%;background:#000;color:#fff;padding:10px 14px;font-size:13px;font-weight:400;line-height:1.45}",
      ".bnya-verdict{border:1px solid " + TRAIT + ";background:#fff;animation:bnyaMonte .3s cubic-bezier(.2,.8,.2,1)}",
      ".bnya-verdict.bnya-sombre{border-color:#000}",
      "@keyframes bnyaMonte{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}",
      ".bnya-bandeau{padding:11px 14px;display:flex;align-items:center;gap:10px}",
      ".bnya-statut{display:flex;align-items:center;gap:10px;font-size:10px;font-weight:800;letter-spacing:2.2px;text-transform:uppercase}",
      ".bnya-verdict-titre{margin:0 0 9px;font-size:14px;font-weight:800;letter-spacing:-.4px;text-transform:lowercase;line-height:1.2;color:#000}",
      ".bnya-contenu{padding:13px 15px 14px}",
      ".bnya-reponse{margin:0;font-size:13px;font-weight:400;line-height:1.6;color:#4a4a4a}",
      ".bnya-points{list-style:none;margin:11px 0 0;padding:0;border-top:1px solid " + TRAIT + "}",
      ".bnya-points li{display:flex;gap:10px;padding:8px 0;border-bottom:1px solid " + TRAIT + ";font-size:12.5px;font-weight:400;line-height:1.5;color:#4a4a4a}",
      ".bnya-tiret{flex-shrink:0;margin-top:8px;width:12px;height:1px;background:#000}",
      ".bnya-vigilance{margin-top:11px;background:" + CREME + ";padding:11px 13px;display:flex;gap:10px;align-items:flex-start}",
      ".bnya-vigilance strong{display:block;font-size:9px;font-weight:800;letter-spacing:2.4px;text-transform:uppercase;margin-bottom:5px}",
      ".bnya-vigilance span span{font-size:12.5px;font-weight:400;line-height:1.5;color:#4a4a4a}",
      ".bnya-form{border:1px solid #000;background:#fff}",
      /* Formulaire Globo déplacé dans le fil : on annule ce qui le faisait
         flotter et on le laisse prendre la largeur du panneau. */
      /* Conteneur distinct de `.bnya-form` : les règles `.bnya-form label`
         et `.bnya-form input` sont en `!important` et cassaient les libellés
         flottants du style material de Globo — étiquettes sorties de leur
         champ et affichées en capitales sous lui. Aucune de ces règles ne
         doit atteindre le formulaire embarqué. */
      ".bnya-form-tete{background:" + BEIGE + ";padding:12px 15px;display:flex;align-items:center;justify-content:space-between;gap:10px}",
      ".bnya-form-tete b{font-size:9px;font-weight:800;letter-spacing:2.2px;text-transform:uppercase}",
      ".bnya-form-tete button{border:none;background:none;cursor:pointer;font-family:inherit;font-size:20px;font-weight:300;line-height:1;transform:rotate(45deg);padding:0 3px}",
      ".bnya-form-corps{padding:14px 15px 16px;display:flex;flex-direction:column;gap:9px}",
      ".bnya-form label{display:block;font-size:9px;font-weight:800;letter-spacing:2px;text-transform:uppercase;color:" + GRIS + ";margin-bottom:4px}",
      ".bnya-form input,.bnya-form textarea{width:100%!important;box-sizing:border-box!important;border:1px solid #d8d8d8!important;border-radius:0!important;background:#fff!important;box-shadow:none!important;padding:9px 11px!important;margin:0!important;font-family:inherit!important;font-size:13px!important;font-weight:400!important;line-height:1.4!important;color:#000!important}",
      ".bnya-form textarea{resize:none!important;height:74px!important;min-height:74px!important;max-height:74px!important}",
      ".bnya-form input:focus,.bnya-form textarea:focus{outline:none!important;border-color:#000!important}",
      ".bnya-duo{display:flex;gap:9px}.bnya-duo>div{flex:1;min-width:0}",
      ".bnya-piege{position:absolute!important;left:-9999px!important;width:1px!important;height:1px!important;opacity:0!important}",
      ".bnya-form-envoi{width:100%;border:none;background:#000;color:" + BEIGE + ";padding:13px;font-family:inherit;font-size:10px;font-weight:800;letter-spacing:2.4px;text-transform:uppercase;cursor:pointer;transition:background .2s}",
      ".bnya-form-envoi:hover:not(:disabled){background:#222}",
      ".bnya-form-envoi:disabled{background:#e6e6e6;color:#a5a5a5;cursor:default}",
      ".bnya-form-note{margin:0;font-size:10px;font-weight:400;line-height:1.5;color:#8a8a8a}",
      ".bnya-form-err{margin:0;font-size:11px;font-weight:800;color:#8A1C24}",
      ".bnya-lien{border:none;background:none;padding:0;font-family:inherit;font-size:10px;font-weight:800;letter-spacing:1.4px;text-transform:uppercase;color:#000;text-decoration:underline;text-underline-offset:3px;cursor:pointer}",
      ".bnya-choix{margin-top:12px;display:flex;gap:6px;flex-wrap:wrap}",
      ".bnya-choix button{border:1px solid #000;background:#fff;color:#000;padding:8px 13px;font-family:inherit;font-size:12px;font-weight:800;letter-spacing:-.1px;transition:background .2s,color .2s}",
      ".bnya-choix button:hover{background:#000;color:" + BEIGE + "}",
      ".bnya-sources{margin-top:11px;display:flex;align-items:center;gap:8px;flex-wrap:wrap}",
      ".bnya-sources>span{font-size:9px;font-weight:800;letter-spacing:2.2px;text-transform:uppercase;color:#8a8a8a}",
      ".bnya-ref{padding:5px 9px;border:1px solid " + SABLE + ";background:" + BEIGE + ";color:#000;font-size:9px;font-weight:800;letter-spacing:1.4px;text-transform:uppercase;transition:background .2s,border-color .2s}",
      ".bnya-ref:hover{background:#fff;border-color:#000}",
      ".bnya-attente{display:flex;align-items:center;gap:11px;margin:0;font-size:9px;font-weight:800;letter-spacing:3px;text-transform:uppercase;color:" + GRIS + "}",
      ".bnya-attente i{font-style:normal;animation:bnyaBat 1.1s infinite ease-in-out}",
      ".bnya-attente i:nth-of-type(2){animation-delay:.15s}.bnya-attente i:nth-of-type(3){animation-delay:.3s}",
      "@keyframes bnyaBat{0%,60%,100%{opacity:.2}30%{opacity:1}}",
      ".bnya-erreur{border:1px solid #000;padding:15px 18px;display:flex;gap:11px;align-items:center;font-size:13px;font-weight:300;line-height:1.7;color:" + GRIS2 + "}",
      ".bnya-saisie{flex-shrink:0;border-top:1px solid " + TRAIT + ";padding:14px 18px 16px}",
      ".bnya-champ{display:flex;align-items:stretch;border:1px solid #000;min-height:44px}",
      ".bnya-champ textarea{flex:1!important;min-width:0!important;resize:none!important;border:none!important;outline:none!important;background:transparent!important;box-shadow:none!important;border-radius:0!important;padding:12px 13px!important;margin:0!important;font-family:inherit!important;font-size:13px!important;font-weight:400!important;line-height:1.4!important;color:#000!important;height:44px;min-height:44px!important;max-height:110px!important;overflow-y:auto}",
      ".bnya-envoi{flex-shrink:0;width:44px;border:none;padding:0;font-size:15px;font-weight:800;display:flex;align-items:center;justify-content:center;background:#000;color:" + BEIGE + ";transition:background .2s}",
      ".bnya-envoi:hover:not(:disabled){background:#222}",
      ".bnya-envoi:disabled{background:#e6e6e6;color:#a5a5a5;cursor:default}",
      ".bnya-mention{margin:9px 0 0;font-size:10px;font-weight:400;line-height:1.55;color:#8a8a8a}",
      ".bnya-plus{border:none;background:none;padding:0;margin-left:4px;font-family:inherit;font-size:10px;color:#000;text-decoration:underline;text-underline-offset:2px;cursor:pointer}",
      ".bnya-carte{width:100%;text-align:left;background:#fff;color:#000;border:1px solid #e2e2e2;padding:14px 16px;display:flex;flex-direction:column;gap:7px;margin-bottom:7px;transition:background .25s,color .25s,border-color .25s}",
      ".bnya-carte.on{background:#000;color:#fff;border-color:#000}",
      ".bnya-carte-tete{display:flex;align-items:center;justify-content:space-between;gap:10px;font-size:9px;font-weight:800;letter-spacing:2.4px;text-transform:uppercase;color:" + GRIS + "}",
      ".bnya-carte.on .bnya-carte-tete{color:rgba(255,255,255,.82)}",
      ".bnya-carte-taux{font-size:24px;font-weight:900;letter-spacing:-1.1px;line-height:1}",
      ".bnya-carte.on .bnya-carte-taux{color:" + BEIGE + "}",
      ".bnya-carte-bas{font-size:11px;font-weight:300;line-height:1.55;color:" + GRIS + "}",
      ".bnya-carte.on .bnya-carte-bas{color:rgba(255,255,255,.82)}",
      ".bnya-sous{margin:0 0 9px;font-size:9px;font-weight:800;letter-spacing:2.4px;text-transform:uppercase;color:" + GRIS + "}",
      ".bnya-plafonds{display:flex;gap:5px}",
      ".bnya-plafonds button{flex:1;padding:10px 2px;font-size:11px;font-weight:800;border:1px solid " + SABLE + ";background:#fff;color:" + GRIS + ";transition:background .2s,color .2s,border-color .2s}",
      ".bnya-plafonds button.on{background:#000;border-color:#000;color:" + BEIGE + "}",
      ".bnya-prev{width:100%;padding:14px 16px;display:flex;align-items:center;justify-content:space-between;gap:10px;border:1px solid " + SABLE + ";background:#fff;transition:background .25s,border-color .25s}",
      ".bnya-prev.on{background:" + BEIGE + ";border-color:#000}",
      ".bnya-prev span:first-child{font-size:10px;font-weight:800;letter-spacing:2px;text-transform:uppercase}",
      ".bnya-prev span:last-child{font-size:12px;font-weight:300;color:" + GRIS + "}",
      ".bnya-prev:disabled{opacity:.45;cursor:not-allowed}",
      ".bnya-note{margin:20px 0 0;padding-top:16px;border-top:1px solid " + SABLE + ";font-size:11px;font-weight:300;line-height:1.8;color:" + GRIS + "}",
      ".bnya-voile{position:fixed;inset:0;z-index:2147483000;background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;padding:18px}",
      ".bnya-fiche{width:100%;max-width:540px;background:#fff}",
      ".bnya-fiche-tete{background:" + BEIGE + ";padding:20px 24px;display:flex;align-items:flex-start;justify-content:space-between;gap:16px}",
      ".bnya-fiche-tete b{display:block;font-size:9px;font-weight:800;letter-spacing:2.4px;text-transform:uppercase;color:rgba(0,0,0,.66)}",
      ".bnya-fiche-tete strong{display:block;margin-top:5px;font-size:22px;font-weight:900;letter-spacing:-1px;text-transform:lowercase;line-height:1.05}",
      ".bnya-fermer{border:none;background:transparent;font-size:22px;font-weight:300;line-height:1;transform:rotate(45deg);padding:2px 6px}",
      ".bnya-fiche p{margin:0;padding:22px 24px 26px;font-size:13.5px;font-weight:300;line-height:1.85;color:" + GRIS2 + "}",
      ".bnya-fiche p.bnya-source{padding:0 24px 22px;font-size:10px;font-weight:800;letter-spacing:1.6px;text-transform:uppercase;color:" + GRIS + "}",
      ".bnya-champ:focus-within{box-shadow:inset 0 0 0 1px #000}",
      ".bnya button:focus-visible{outline:2px solid #000;outline-offset:2px}",
      "@media (max-width:860px){.bnya-aside{display:none}.bnya-fil{max-height:none;min-height:340px}.bnya-corps{min-height:0}}",
      "@media (prefers-reduced-motion:reduce){.bnya *,.bnya *::before,.bnya *::after{animation-duration:.001ms!important;transition-duration:.05ms!important}}"
    ].join("\n");
    document.head.appendChild(s);
  }

  /* --------------------------- composant --------------------------- */

  function monter(racine) {
    var cfg = window.__BNY_ASSISTANT || {};
    var relais = cfg.relais || racine.getAttribute("data-relais");
    if (!relais) return;

    var formuleDemandee = cfg.formule || racine.getAttribute("data-formule");

    var etat = {
      formule: FORMULES[formuleDemandee] ? formuleDemandee : "Smart",
      prevention: true,
      plafond: 2000,
      echanges: [],
      enCours: false,
      erreur: null,
      contact: false,
      envoye: false
    };

    /* ——— Persistance de session ———
       `sessionStorage` et non `localStorage` : le fil survit à un
       rechargement et à une navigation dans l'onglet, et disparaît à sa
       fermeture. Rien ne subsiste d'une visite à l'autre, donc rien de
       nouveau à déclarer côté données personnelles.
       Toute écriture est enveloppée : en navigation privée ou quota atteint,
       `sessionStorage` lève, et l'assistant doit continuer sans historique
       plutôt que de s'arrêter. */
    var CLE_FIL = "bny-fil";

    function sauverFil() {
      try {
        sessionStorage.setItem(CLE_FIL, JSON.stringify({
          v: 1, echanges: etat.echanges, formule: etat.formule,
          prevention: etat.prevention, plafond: etat.plafond
        }));
      } catch (e) {}
    }

    function reprendreFil() {
      try {
        var brut = sessionStorage.getItem(CLE_FIL);
        if (!brut) return;
        var o = JSON.parse(brut);
        if (!o || o.v !== 1 || !Array.isArray(o.echanges)) return;
        etat.echanges = o.echanges;
        if (FORMULES[o.formule]) etat.formule = o.formule;
        if (typeof o.prevention === "boolean") etat.prevention = o.prevention;
        if (typeof o.plafond === "number") etat.plafond = o.plafond;
      } catch (e) {}
    }
    reprendreFil();

    function effacerFil() {
      etat.echanges = [];
      etat.contact = false;
      etat.envoye = false;
      etat.erreur = null;
      try { sessionStorage.removeItem(CLE_FIL); } catch (e) {}
    }
    if (etat.formule === "Accessible") etat.prevention = false;

    var avecSelecteur = cfg.selecteur !== false && racine.getAttribute("data-selecteur") !== "0";

    styles();
    racine.innerHTML = "";
    /* Le widget vit dans une boîte à lui : le point d'ancrage reste tel que
       le moteur de rendu de la page l'a produit, et n'est jamais réécrit. */
    var boite = el("div", "bnya");
    racine.appendChild(boite);

    /* Surface publique minimale : la coque de la page (onglets, composeur
       d'accueil) pose des questions sans connaître le DOM de l'assistant. */
    window.banayaAssistant = {
      poser: function (texte) { envoyer(texte); },
      effacer: function () { effacerFil(); peindreFil(); },
      nombreEchanges: function () { return etat.echanges.length; }
    };

    var corps = el("div", "bnya-corps");
    var aside = el("aside", "bnya-aside");
    var main = el("div", "bnya-main");
    var fil = el("div", "bnya-fil");
    var zoneSaisie = el("div", "bnya-saisie");

    if (avecSelecteur) corps.appendChild(aside);
    corps.appendChild(main);
    main.appendChild(fil);
    main.appendChild(zoneSaisie);
    boite.appendChild(corps);

    /* ----------------------- colonne formule ----------------------- */

    function peindreAside() {
      aside.innerHTML = "";
      aside.appendChild(cartouche("le contrat"));

      var h = el("h3", "bnya-titre");
      h.style.fontSize = "24px";
      h.style.margin = "12px 0 18px";
      h.innerHTML = "votre<br><em>formule.</em>";
      aside.appendChild(h);

      ["Accessible", "Smart", "Premium"].forEach(function (nom) {
        var f = FORMULES[nom], actif = etat.formule === nom;
        var b = el("button", "bnya-carte" + (actif ? " on" : ""));
        b.type = "button";

        var tete = el("div", "bnya-carte-tete");
        tete.appendChild(el("span", null, nom));
        if (actif) tete.appendChild(pastille(BEIGE, NOIR, "\u2713", 18));
        b.appendChild(tete);

        b.appendChild(el("div", "bnya-carte-taux", f.taux));
        b.appendChild(el("div", "bnya-carte-bas",
          "plafond " + (nom === "Premium" ? etat.plafond.toLocaleString("fr-FR") + " €" : f.plafond)));

        b.addEventListener("click", function () {
          etat.formule = nom;
          if (nom === "Accessible") etat.prevention = false;
          peindreAside();
        });
        aside.appendChild(b);
      });

      if (etat.formule === "Premium") {
        var bloc = el("div");
        bloc.style.marginTop = "16px";
        bloc.appendChild(el("p", "bnya-sous", "plafond retenu"));
        var rangee = el("div", "bnya-plafonds");
        [1000, 2000, 3000].forEach(function (p) {
          var b = el("button", etat.plafond === p ? "on" : null, p.toLocaleString("fr-FR") + " €");
          b.type = "button";
          b.addEventListener("click", function () { etat.plafond = p; peindreAside(); });
          rangee.appendChild(b);
        });
        bloc.appendChild(rangee);
        aside.appendChild(bloc);
      }

      var blocPrev = el("div");
      blocPrev.style.marginTop = "16px";
      blocPrev.appendChild(el("p", "bnya-sous", "option prévention"));
      var bp = el("button", "bnya-prev" + (etat.prevention ? " on" : ""));
      bp.type = "button";
      bp.disabled = etat.formule === "Accessible";
      bp.appendChild(el("span", null,
        etat.formule === "Accessible" ? "indisponible" : etat.prevention ? "souscrite" : "non souscrite"));
      bp.appendChild(el("span", null,
        etat.formule === "Accessible" ? "—" : FORMULES[etat.formule].prev + "/an"));
      bp.addEventListener("click", function () {
        if (etat.formule === "Accessible") return;
        etat.prevention = !etat.prevention;
        peindreAside();
      });
      blocPrev.appendChild(bp);
      aside.appendChild(blocPrev);

      aside.appendChild(el("p", "bnya-note",
        "Les réponses tiennent compte de la formule sélectionnée. Changez-la pour comparer une autre situation."));
    }

    /* --------------------------- fiche --------------------------- */

    function ouvrirFiche(code) {
      if (!REFS[code]) return;
      var voile = el("div", "bnya-voile");
      var fiche = el("div", "bnya-fiche");
      var tete = el("div", "bnya-fiche-tete");
      var gauche = el("div");
      gauche.appendChild(el("b", null, "article § " + code));
      gauche.appendChild(el("strong", null, REFS[code][0]));
      var fermer = el("button", "bnya-fermer", "+");
      fermer.type = "button";
      fermer.setAttribute("aria-label", "Fermer");
      tete.appendChild(gauche);
      tete.appendChild(fermer);
      fiche.appendChild(tete);
      fiche.appendChild(el("p", null, REFS[code][1]));
      fiche.appendChild(el("p", "bnya-source", "— extrait de la notice d'information"));
      voile.appendChild(fiche);
      document.body.appendChild(voile);

      function partir() { voile.remove(); document.removeEventListener("keydown", surTouche); }
      function surTouche(e) { if (e.key === "Escape") partir(); }
      voile.addEventListener("click", function (e) { if (e.target === voile) partir(); });
      fermer.addEventListener("click", partir);
      document.addEventListener("keydown", surTouche);
      fermer.focus();
    }

    /* --------------------------- réponses --------------------------- */

    function bulleVerdict(d) {
      var t = STATUTS[d.statut] || STATUTS["HORS PÉRIMÈTRE"];
      var art = el("article", "bnya-verdict" + (t.fond === NOIR ? " bnya-sombre" : ""));

      var bandeau = el("div", "bnya-bandeau");
      bandeau.style.background = t.fond;
      bandeau.style.color = t.texte;
      var st = el("span", "bnya-statut");
      st.appendChild(pastille(t.past, t.pg, t.glyphe, 20));
      st.appendChild(el("span", null, d.statut));
      bandeau.appendChild(st);
      art.appendChild(bandeau);

      var contenu = el("div", "bnya-contenu");
      if (d.titre) contenu.appendChild(el("p", "bnya-verdict-titre", d.titre));
      contenu.appendChild(el("p", "bnya-reponse", d.reponse || ""));

      if (Array.isArray(d.points) && d.points.length) {
        var ul = el("ul", "bnya-points");
        d.points.forEach(function (p) {
          var li = el("li");
          var tir = el("span", "bnya-tiret");
          tir.setAttribute("aria-hidden", "true");
          li.appendChild(tir);
          li.appendChild(el("span", null, p));
          ul.appendChild(li);
        });
        contenu.appendChild(ul);
      }

      if (d.contact === true) {
        var vers = el("div", "bnya-choix");
        var bc = el("button", null, "écrire à Banaya");
        bc.type = "button";
        bc.addEventListener("click", function () { etat.contact = true; peindreFil(); });
        vers.appendChild(bc);
        contenu.appendChild(vers);
      }

      if (Array.isArray(d.options) && d.options.length) {
        var choix = el("div", "bnya-choix");
        d.options.slice(0, 4).forEach(function (o) {
          if (typeof o !== "string" || !o.trim()) return;
          var b = el("button", null, o.trim().slice(0, 40));
          b.type = "button";
          b.addEventListener("click", function () { envoyer(o); });
          choix.appendChild(b);
        });
        if (choix.children.length) contenu.appendChild(choix);
      }

      if (d.attention) {
        var v = el("div", "bnya-vigilance");
        v.appendChild(pastille(NOIR, BEIGE, "!", 20));
        var bloc = el("span");
        bloc.appendChild(el("strong", null, "à vérifier"));
        bloc.appendChild(el("span", null, d.attention));
        v.appendChild(bloc);
        contenu.appendChild(v);
      }

      if (Array.isArray(d.references) && d.references.length) {
        var src = el("div", "bnya-sources");
        src.appendChild(el("span", null, "source"));
        d.references.forEach(function (r) {
          if (!REFS[r]) return;
          var b = el("button", "bnya-ref", "§ " + r);
          b.type = "button";
          b.addEventListener("click", function () { ouvrirFiche(r); });
          src.appendChild(b);
        });
        if (src.children.length > 1) contenu.appendChild(src);
      }

      art.appendChild(contenu);
      return art;
    }

    /* ------------------------- formulaire ------------------------- */

    function champ(cle, libelle, type, obligatoire) {
      var b = el("div");
      var l = el("label", null, libelle + (obligatoire ? "" : " (facultatif)"));
      l.setAttribute("for", "bnya-" + cle);
      var i = el(type === "message" ? "textarea" : "input");
      i.id = "bnya-" + cle;
      i.name = cle;
      if (type !== "message") i.type = type;
      i.setAttribute("autocomplete",
        { prenom: "given-name", nom: "family-name", email: "email" }[cle] || "off");
      b.appendChild(l);
      b.appendChild(i);
      return { bloc: b, saisie: i };
    }

    function formulaireNatif() {
      var f = el("div", "bnya-form");

      var tete = el("div", "bnya-form-tete");
      tete.appendChild(el("b", null, "écrire à banaya"));
      f.appendChild(tete);

      var corps = el("div", "bnya-form-corps");
      var prenom = champ("prenom", "Prénom", "text", true);
      var nom = champ("nom", "Nom", "text", true);
      var duo = el("div", "bnya-duo");
      duo.appendChild(prenom.bloc);
      duo.appendChild(nom.bloc);
      corps.appendChild(duo);

      var email = champ("email", "E-mail", "email", true);
      var contrat = champ("contrat", "N° de contrat", "text", false);
      var message = champ("message", "Votre message", "message", true);
      corps.appendChild(email.bloc);
      corps.appendChild(contrat.bloc);
      corps.appendChild(message.bloc);

      var piege = el("input", "bnya-piege");
      piege.type = "text";
      piege.name = "societe";
      piege.tabIndex = -1;
      piege.setAttribute("aria-hidden", "true");
      piege.setAttribute("autocomplete", "off");
      corps.appendChild(piege);

      var erreur = el("p", "bnya-form-err");
      erreur.style.display = "none";
      corps.appendChild(erreur);

      var envoi = el("button", "bnya-form-envoi", "envoyer ma demande");
      envoi.type = "button";
      corps.appendChild(envoi);

      corps.appendChild(el("p", "bnya-form-note",
        "Votre demande part chez Banaya, qui vous répond par e-mail. Le numéro de contrat n\u2019est utile que si vous êtes déjà assuré."));

      f.appendChild(corps);

      envoi.addEventListener("click", function () {
        var d = {
          prenom: prenom.saisie.value.trim(),
          nom: nom.saisie.value.trim(),
          email: email.saisie.value.trim(),
          contrat: contrat.saisie.value.trim(),
          message: message.saisie.value.trim(),
          piege: piege.value
        };
        if (!d.prenom || !d.nom || !d.email || !d.message) {
          erreur.textContent = "Prénom, nom, e-mail et message sont nécessaires.";
          erreur.style.display = "block";
          return;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(d.email)) {
          erreur.textContent = "Cette adresse e-mail ne semble pas valide.";
          erreur.style.display = "block";
          return;
        }
        erreur.style.display = "none";
        envoi.disabled = true;
        envoi.textContent = "envoi en cours\u2026";

        envoyerContact(d)
          .then(function (reference) {
            etat.contact = false;
            etat.envoye = true;
            etat.reference = reference;
            peindreFil();
          })
          .catch(function () {
            envoi.disabled = false;
            envoi.textContent = "envoyer ma demande";
            erreur.textContent = "L\u2019envoi n\u2019a pas abouti. Réessayez, ou écrivez à contact@banaya.fr.";
            erreur.style.display = "block";
          });
      });

      return f;
    }

    /* ——————————————————— dépôt de la demande de contact ———————————————————
       Le formulaire affiché est celui de Banaya, pas celui de Globo.

       Embarquer le formulaire Globo dans le panneau ne tenait pas : ses champs
       sont dessinés au style « material » de son éditeur — étiquettes
       flottantes, fonds gris, gabarit large — et le rhabiller revenait à se
       battre contre sa feuille de style dans un panneau de 400 px. On garde
       donc notre formulaire, et on ne prend de Globo que ce qui compte : son
       point de dépôt.

       La correspondance des champs se fait à l'exécution, sur le formulaire
       Globo resté en place et masqué : on lit ses libellés et on y recopie les
       valeurs saisies. Plus robuste qu'une liste de noms de champs en dur, que
       le moindre remaniement dans l'éditeur Globo casserait.
       ——————————————————————————————————————————————————————————————————— */
    var RELAIS_GLOBO = "https://app.powerfulform.com/api/front/form/156670/send";

    function formGlobo() {
      return document.querySelector(".globo-formbuilder form")
          || document.querySelector(".globo-form form")
          || document.querySelector("form[action*='powerfulform']")
          || null;
    }

    function libelle(champ) {
      var t = champ.getAttribute("placeholder") || champ.getAttribute("aria-label") || "";
      if (!t && champ.id) {
        var l = document.querySelector('label[for="' + champ.id + '"]');
        if (l) t = l.textContent || "";
      }
      if (!t && champ.parentNode) t = champ.parentNode.textContent || "";
      return t.toLowerCase();
    }

    function remplirGlobo(form, d) {
      var champs = form.querySelectorAll("input, textarea");
      var restants = [];
      Array.prototype.forEach.call(champs, function (c) {
        var type = (c.type || "").toLowerCase();
        if (type === "hidden" || type === "submit" || type === "button") return;
        var t = libelle(c);
        if (c.tagName === "TEXTAREA" || t.indexOf("message") > -1) { c.value = d.message; return; }
        if (type === "email" || t.indexOf("mail") > -1) { c.value = d.email; return; }
        if (/contrat|commande/.test(t)) { c.value = d.contrat; return; }
        if (/pr[e\u00e9]nom|nom/.test(t)) { c.value = d.prenom + " " + d.nom; return; }
        restants.push(c);
      });
      /* Repli positionnel si les libellés n'ont rien dit. */
      var ordre = [d.prenom + " " + d.nom, d.email, d.contrat, d.message];
      restants.forEach(function (c, i) { if (!c.value && ordre[i]) c.value = ordre[i]; });
      /* Un champ piloté par un cadre applicatif n'enregistre la valeur que si
         l'évènement est émis. */
      Array.prototype.forEach.call(champs, function (c) {
        c.dispatchEvent(new Event("input", { bubbles: true }));
        c.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }

    function envoyerContact(d) {
      var form = formGlobo();
      var corps, url;
      if (form) {
        remplirGlobo(form, d);
        corps = new FormData(form);
        url = form.getAttribute("action") || RELAIS_GLOBO;
        if (url.indexOf("http") !== 0) url = RELAIS_GLOBO;
      } else {
        corps = new FormData();
        corps.append("nom", d.prenom + " " + d.nom);
        corps.append("email", d.email);
        corps.append("contrat", d.contrat);
        corps.append("message", d.message);
        url = RELAIS_GLOBO;
      }
      return fetch(url, { method: "POST", body: corps })
        .then(function (r) { return r.text(); })
        .then(function (txt) {
          if (!/"success"\s*:\s*"?true"?/i.test(txt)) throw new Error("refus");
          var m = txt.match(/"id"\s*:\s*"?(\d+)"?/);
          return m ? m[1] : null;
        });
    }

    /* Plus aucun déplacement de nœud : le formulaire Globo reste où il est,
       masqué par la feuille de la page. Toutes les avaries d'affichage
       venaient de ce déplacement. */
    function formulaire() { return formulaireNatif(); }


    /* ----------------------------- fil ----------------------------- */

    function peindreFil() {
      sauverFil();
      fil.innerHTML = "";

      if (!etat.echanges.length) {
        fil.appendChild(cartouche("poser une situation"));
        var h1 = el("h2", "bnya-titre");
        h1.innerHTML = "que couvre le contrat,<br><em>exactement ?</em>";
        fil.appendChild(h1);
        fil.appendChild(el("p", "bnya-intro",
          "Décrivez une situation, je vous dis si le contrat la prend en charge — et sur quel article je m’appuie."));
        fil.appendChild(el("p", "bnya-exemples", "exemples"));

        var liste = el("div", "bnya-amorces");
        AMORCES.forEach(function (a) {
          var b = el("button", "bnya-amorce");
          b.type = "button";
          b.appendChild(el("span", null, a));
          var f = el("span", "bnya-fleche", "\u2192");
          f.setAttribute("aria-hidden", "true");
          b.appendChild(f);
          b.addEventListener("click", function () { envoyer(a); });
          liste.appendChild(b);
        });
        fil.appendChild(liste);
      }

      var pile = el("div", "bnya-echanges");
      etat.echanges.forEach(function (m) {
        if (m.role === "user") {
          pile.appendChild(el("div", "bnya-question", m.contenu));
        } else if (m.donnees) {
          pile.appendChild(bulleVerdict(m.donnees));
        } else {
          var brut = el("div", "bnya-verdict");
          var c = el("div", "bnya-contenu");
          c.appendChild(el("p", "bnya-reponse", m.contenu));
          brut.appendChild(c);
          pile.appendChild(brut);
        }
      });

      if (etat.enCours) {
        var att = el("p", "bnya-attente");
        var fi = el("span", "bnya-filet");
        fi.setAttribute("aria-hidden", "true");
        att.appendChild(fi);
        att.appendChild(document.createTextNode("lecture du contrat"));
        var pts = el("span");
        pts.setAttribute("aria-hidden", "true");
        pts.appendChild(el("i", null, "·"));
        pts.appendChild(el("i", null, "·"));
        pts.appendChild(el("i", null, "·"));
        att.appendChild(pts);
        pile.appendChild(att);
      }

      if (etat.contact) pile.appendChild(formulaire());

      if (etat.envoye) {
        var recu = el("div", "bnya-verdict");
        var bandeauR = el("div", "bnya-bandeau");
        bandeauR.style.background = BEIGE;
        bandeauR.style.color = NOIR;
        var sttR = el("span", "bnya-statut");
        sttR.appendChild(pastille(NOIR, BEIGE, "\u2713", 20));
        sttR.appendChild(el("span", null, "demande envoyée"));
        bandeauR.appendChild(sttR);
        recu.appendChild(bandeauR);
        var crR = el("div", "bnya-contenu");
        crR.appendChild(el("p", "bnya-reponse",
          "Votre message est parti chez Banaya. La réponse arrivera par e-mail, à l\u2019adresse que vous avez indiquée."));
        recu.appendChild(crR);
        pile.appendChild(recu);
      }

      if (etat.erreur) {
        var e = el("div", "bnya-erreur");
        e.appendChild(pastille(NOIR, BEIGE, "!", 20));
        e.appendChild(el("span", null, etat.erreur));
        pile.appendChild(e);
      }

      fil.appendChild(pile);

      /* On aligne le haut du dernier verdict : une réponse longue doit se lire
         depuis son statut, pas depuis sa dernière ligne. */
      var verdicts = pile.querySelectorAll(".bnya-verdict");
      var dernier = verdicts.length ? verdicts[verdicts.length - 1] : null;
      if (dernier && !etat.enCours) {
        fil.scrollTop = Math.max(0, dernier.offsetTop - fil.offsetTop - 10);
      } else {
        fil.scrollTop = fil.scrollHeight;
      }
    }

    /* --------------------------- saisie --------------------------- */

    var champSaisie = el("div", "bnya-champ");
    var zone = el("textarea");
    zone.rows = 1;
    zone.placeholder = "Mon chien s’est blessé…";
    zone.setAttribute("aria-label", "Votre question sur les garanties");
    var envoi = el("button", "bnya-envoi", "\u2192");
    envoi.type = "button";
    envoi.disabled = true;
    envoi.setAttribute("aria-label", "Envoyer la question");
    champSaisie.appendChild(zone);
    champSaisie.appendChild(envoi);
    zoneSaisie.appendChild(champSaisie);
    var mention = el("p", "bnya-mention");
    var mentionTexte = el("span", null, MENTION_COURTE);
    var mentionPlus = el("button", "bnya-plus", "en savoir plus");
    mentionPlus.type = "button";
    mentionPlus.addEventListener("click", function () {
      var deplie = mentionTexte.textContent === MENTION_COURTE;
      mentionTexte.textContent = deplie ? MENTION_LONGUE : MENTION_COURTE;
      mentionPlus.textContent = deplie ? "réduire" : "en savoir plus";
    });
    mention.appendChild(mentionTexte);
    mention.appendChild(mentionPlus);
    zoneSaisie.appendChild(mention);

    var versContact = el("button", "bnya-lien", "écrire à Banaya");
    versContact.type = "button";
    versContact.style.marginTop = "8px";
    versContact.addEventListener("click", function () {
      if (etat.contact) return;
      etat.contact = true;
      etat.envoye = false;
      peindreFil();
    });
    zoneSaisie.appendChild(versContact);

    function majEnvoi() {
      envoi.disabled = etat.enCours || !zone.value.trim();
    }
    function ajuste() {
      zone.style.height = "44px";
      var h = Math.min(Math.max(zone.scrollHeight, 44), 110);
      zone.style.height = h + "px";
    }
    zone.addEventListener("input", function () { ajuste(); majEnvoi(); });
    zone.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); envoyer(); }
    });
    envoi.addEventListener("click", function () { envoyer(); });

    /* --------------------------- échange --------------------------- */

    /* Une demande de contact humain n'a rien à faire au relais : le modèle
       n'a pas de réponse contractuelle à donner. On ouvre le formulaire. */
    var VERS_HUMAIN = new RegExp(
      "humain|conseill|un agent|une personne|service client|\\bsav\\b|" +
      "(contacter|joindre|appeler|\u00e9crire \u00e0|ecrire a|parler \u00e0|parler a) *(vous|banaya|quelqu)|" +
      "parler (\u00e0|a) (un|une|quelqu)", "i");

    function envoyer(texte) {
      var question = (texte != null ? texte : zone.value).trim();
      if (!question || etat.enCours) return;

      if (VERS_HUMAIN.test(question)) {
        zone.value = "";
        zone.style.height = "44px";
        etat.erreur = null;
        etat.envoye = false;
        etat.echanges.push({ role: "user", contenu: question });
        etat.echanges.push({ role: "assistant", contenu:
          "Cette demande sort de ce que je peux lire dans le contrat. Laissez vos coordonn\u00e9es ci-dessous, l\u2019\u00e9quipe Banaya vous r\u00e9pond par e-mail." });
        etat.contact = true;
        majEnvoi();
        peindreFil();
        return;
      }

      zone.value = "";
      zone.style.height = "44px";
      etat.erreur = null;
      etat.envoye = false;
      etat.echanges.push({ role: "user", contenu: question });
      etat.enCours = true;
      majEnvoi();
      peindreFil();

      var historique = etat.echanges.map(function (m) {
        return {
          role: m.role === "user" ? "user" : "assistant",
          content: m.role === "user" ? m.contenu : ((m.donnees && m.donnees.reponse) || m.contenu || "")
        };
      });

      fetch(relais, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          messages: historique,
          formule: avecSelecteur ? etat.formule : null,
          prevention: etat.prevention,
          plafond: etat.plafond
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error("relais " + r.status);
          return r.json();
        })
        .then(function (d) {
          if (!d || !d.ok) throw new Error("réponse");
          if (d.brut) etat.echanges.push({ role: "assistant", contenu: d.brut, donnees: null });
          else etat.echanges.push({ role: "assistant", donnees: d });
        })
        .catch(function () {
          etat.echanges.pop();
          zone.value = question;
          etat.erreur = "La réponse n'a pas abouti. Reformulez la question ou relancez l'envoi. Vous pouvez aussi écrire à contact@banaya.fr.";
        })
        .then(function () {
          etat.enCours = false;
          majEnvoi();
          peindreFil();
        });
    }

    if (avecSelecteur) peindreAside();
    peindreFil();
  }

  var ancrage = null;

  function demarrer() {
    var racine = document.getElementById("banaya-assistant");
    if (!racine || racine === ancrage) return;
    ancrage = racine;
    monter(racine);
  }

  demarrer();
  document.addEventListener("DOMContentLoaded", demarrer);
  window.addEventListener("load", demarrer);

  if (window.MutationObserver) {
    new MutationObserver(demarrer).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Filet de sécurité si l'observateur n'est pas disponible. */
  var essais = 0;
  var minuteur = setInterval(function () {
    demarrer();
    if (ancrage || ++essais > 40) clearInterval(minuteur);
  }, 250);
})();